export enum API_CODE {
  OK = '0',
  Created = '201',
  Unauthorized = '401',
  Forbidden = '403',
  NotFound = '404',
  LinkedModuleNotCommited = '7201', // 依赖模块未提交
  ModuleAlreadySaved = '7202', // 模块数据已完成录入
  ModuleNotFound = '7203', // 模块不存在
  RepeatedOperation = '7204', // 重复操作
  CollectionNotFound = '7206', // 收集单不存在
  CollectionFinished = '7207', // 收集单已结束收集
  CollectionAbandon = '7208', // 收集单已被废弃
  TenantNotMatch = '7209', // 租户模块不匹配
}
